export class CalendarButtonsModel {
  today: string;
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/calendar/calendar-buttons.model.ts